import React from "react";
import { useNavigate } from "react-router-dom";

import school from "../assets/school.jpg";

const HomeAbout = () => {
  const navigate = useNavigate();

  return (
    <section
      className="relative w-full py-16 md:py-24 overflow-hidden"
      style={{
        backgroundImage: `url(${school})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* DARK OVERLAY */}
      <div className="absolute inset-0 bg-white/80 backdrop-blur-[2px]" />

      {/* MAIN CONTAINER */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        
        {/* GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch">

          {/* LEFT SIDE */}
          <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-6 md:p-10 border border-gray-200">
            
            {/* TITLE */}
            <h2 className="text-[#072F5F] text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-tight uppercase">
              Welcome To
              <span className="block text-[#0B4F9C] mt-2">
                St.Joseph's School
              </span>
            </h2>

            {/* DESCRIPTION */}
            <div className="mt-8 space-y-6">
              <p className="text-gray-700 text-base md:text-lg leading-8 text-justify">
                St. Joseph's School is named after St. Joseph, step father of
                Jesus Christ. It is an ideal English Medium school for boys and
                girls, governed by Miss Jancy Memorial Welfare Society, a
                christian minority society.
              </p>

              <p className="text-gray-700 text-base md:text-lg leading-8 text-justify">
                It is situated in the heart of Maharajganj town with spacious
                compound and safe surroundings. The aim of this institution is
                to impart a thorough and practical school education and sound
                moral training that creates praiseworthy character and balanced
                judgement in students.
              </p>
            </div>

            {/* MOTTO */}
            <div className="mt-10 bg-[#F8FAFC] border-l-4 border-red-500 rounded-xl p-5">
              <p className="text-gray-700 text-lg">
                The Motto of the School :--
              </p>

              <h3 className="text-3xl md:text-4xl font-bold italic text-red-600 mt-2">
                “From Darkness to Light”
              </h3>
            </div>

            {/* BUTTON */}
            <button
              onClick={() => navigate("/about")}
              className="mt-10 bg-[#072F5F] hover:bg-[#0B4F9C] text-white px-8 py-4 rounded-xl uppercase tracking-wide font-semibold transition-all duration-300 shadow-lg hover:scale-105"
            >
              Read More
            </button>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex flex-col gap-6">

            {/* COMPETITIVE EXAMS */}
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-6 md:p-8 border border-gray-200 h-full">
              
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 rounded-full bg-[#072F5F] flex items-center justify-center text-white text-xl font-bold">
                  01
                </div>

                <h4 className="text-2xl font-bold text-[#072F5F]">
                  Competitive Exams
                </h4>
              </div>

              <p className="text-gray-700 leading-8 text-justify text-base md:text-lg">
                Apart from academics we encourage students’ participation at
                various State and National level competitive exams like NSTSE,
                Mathematics Olympiad, Science Olympiad, English Olympiad,
                Computer Olympiad, National Science Congress, Scholarship,
                SanskaraShaala and GK competitions.
              </p>
            </div>

            {/* SALIENT FEATURES */}
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-6 md:p-8 border border-gray-200 h-full">
              
              <div className="flex items-center gap-3 mb-5">
                <div className="w-12 h-12 rounded-full bg-[#0B4F9C] flex items-center justify-center text-white text-xl font-bold">
                  02
                </div>

                <h4 className="text-2xl font-bold text-[#072F5F]">
                  Salient Features
                </h4>
              </div>

              {/* FEATURES GRID */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {[
                  "Educomp Smart Classes",
                  "Language Lab",
                  "Wi-Fi Computer Lab",
                  "Maths Lab",
                  "Science Lab",
                  "Activity Room",
                  "Music & Dance",
                  "Library Section",
                  "Basketball Court",
                  "Volleyball Court",
                  "Badminton Court",
                  "CCTV Surveillance",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-3 bg-gray-50 rounded-xl p-3 border border-gray-100 hover:border-[#0B4F9C] transition"
                  >
                    <div className="w-2.5 h-2.5 rounded-full bg-[#0B4F9C] mt-2" />

                    <p className="text-gray-700 text-sm md:text-base leading-6">
                      {item}
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeAbout;